<div class="flex items-center mt-2 gap-2 cursor-pointer" (click)="onDelete()">
  <button
    type="button"
    class="w-8 h-8 flex items-center justify-center rounded-full bg-th-red text-white cursor-pointer"
    title="Eliminar"
  >
    <mat-icon svgIcon="delete-icon" class="w-5! h-5!"></mat-icon>
  </button>

  <p class="text-[14px] font-medium text-th-dark-blue">Eliminar</p>
  
</div>
